module.exports = __webpack_public_path__ + "static/media/mobileSpashScreen.e79dd9de.webp";